import { styled } from '@mui/material/styles'

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const AnimationWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== 'spaceUnderAnimation',
})<{ spaceUnderAnimation?: boolean }>(({ spaceUnderAnimation, theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  ...(spaceUnderAnimation && { marginBottom: theme.spacing(4) }),
}))
